import { Col, Row } from "react-bootstrap";
import { useState, useMemo, memo } from "react";
import Slider from "react-slick";

const ImageGallery = memo((props) => {

    const [sliderSettings] = useState({
        infinite: true,
        dots: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
      })

    // Memoize image URLs to prevent recalculation on every render
    const imageUrls = useMemo(() => {
        if (props.img) {
            return {
                one: props.img,
                two: props.img,
                three: props.img,
                four: props.img,
                five: props.img,
                six: props.img
            };
        }
        return {
            one: props.images?.galleryOne,
            two: props.images?.galleryTwo,
            three: props.images?.galleryThree,
            four: props.images?.galleryFour,
            five: props.images?.galleryFive,
            six: props.images?.gallerySix
        };
    }, [props.img, props.images]);


  return (
    <div className="px-xxl-0 px-md-5 px-0">
        
    <Row className="d-none d-xl-flex">
        <Col lg={4}>
            <div style={{backgroundImage: `url(${imageUrls.one})`}}  className={`sds-activity-image activity-one ${props.img ? "background-fixed" : ""}`} />
        </Col>
        <Col lg={4}>
            <div style={{backgroundImage: `url(${imageUrls.two})`}} className={`sds-activity-image activity-two ${props.img ? "background-fixed" : ""}`}  />
            <div style={{backgroundImage: `url(${imageUrls.three})`}}  className={`sds-activity-image activity-three ${props.img ? "background-fixed" : ""}`} />
        </Col>
        <Col lg={4}>
            <div style={{backgroundImage: `url(${imageUrls.four})`}} className={`sds-activity-image activity-four ${props.img ? "background-fixed" : ""}`} />
        </Col>
        <Col lg={6}>
            <div style={{backgroundImage: `url(${imageUrls.five})`}}  className={`sds-activity-image activity-five ${props.img ? "background-fixed" : ""}`} />
        </Col>
        <Col lg={6}>
            <div style={{backgroundImage: `url(${imageUrls.six})`}} className={`sds-activity-image activity-six ${props.img ? "background-fixed" : ""}`} />
        </Col>
    </Row>

    
    <Slider {...sliderSettings} className="d-xl-none image-gallery">
        <div>
                <div style={{backgroundImage: `url(${imageUrls.one})`, height: '369px'}}  className={`sds-activity-image activity-one ${props.img ? "background-fixed" : ""}`} />
        </div>
        <div>
                <div style={{backgroundImage: `url(${imageUrls.two})`, height: '369px'}}  className={`sds-activity-image activity-one ${props.img ? "background-fixed" : ""}`} />
        </div>
        <div>
                <div style={{backgroundImage: `url(${imageUrls.three})`, height: '369px'}}  className={`sds-activity-image activity-one ${props.img ? "background-fixed" : ""}`} />
        </div>
        <div>
                <div style={{backgroundImage: `url(${imageUrls.four})`, height: '369px'}}  className={`sds-activity-image activity-one ${props.img ? "background-fixed" : ""}`} />
        </div>
        <div>
                <div style={{backgroundImage: `url(${imageUrls.five})`, height: '369px'}}  className={`sds-activity-image activity-one ${props.img ? "background-fixed" : ""}`} />
        </div>
        <div>
                <div style={{backgroundImage: `url(${imageUrls.six})`, height: '369px'}}  className={`sds-activity-image activity-one ${props.img ? "background-fixed" : ""}`} />
        </div>
    </Slider>
    </div>
  )
});

ImageGallery.displayName = 'ImageGallery';

export default ImageGallery;
